import { DELIVERY_TEAMS_ROUTE } from './wfm-routes';

export const loadWfmLandingPage = () => import('../pages/wfm-landing-page');
export const loadWfmLayerPage = () => import('../pages/wfm-layer-page');
export const loadWfmTeamPage = () => import('../pages/wfm-team-page');

export function whenIdle(task) {
  if (typeof requestIdleCallback === 'function') {
    const id = requestIdleCallback(task);
    return () => cancelIdleCallback(id);
  }
  const id = setTimeout(task, 200);
  return () => clearTimeout(id);
}

export function preloadWfmChunksForPath(pathname) {
  if (typeof pathname !== 'string' || !pathname.startsWith(DELIVERY_TEAMS_ROUTE)) return;
  const rest = pathname.slice(DELIVERY_TEAMS_ROUTE.length);
  let loader = loadWfmLandingPage;
  if (rest.startsWith('/teams/')) loader = loadWfmTeamPage;
  else if (rest.startsWith('/nodes/')) loader = loadWfmLayerPage;
  loader().catch(() => {});
}
